import { block, blockNew } from '../utils/cn';
const ROOT_CLASS_NAME = 'root';
const bNew = blockNew(ROOT_CLASS_NAME);
const b = block(ROOT_CLASS_NAME);
export function getDeprecatedRootClassName(modifier) {
    return b(modifier);
}
export function getRootClassName(modifier, addition) {
    return bNew(modifier, addition);
}
export function getInitialRootClassName(props = {}) {
    const { theme } = props;
    return getRootClassName({ theme });
}
